module.exports = __webpack_public_path__ + "img/file.813312f0.svg";